import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ViewChild
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ListCustomCell } from '@shared/modules/list/interfaces/list-custom-cell.interface';
import { ListService } from '@shared/modules/list/services/list.service';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'project-name-header-cell',
  templateUrl: './project-name-header-cell.component.html',
  styleUrls: ['./project-name-header-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, CommonModule, AngularSvgIconModule]
})
export class ProjectNameHeaderCellComponent implements AfterViewInit, ListCustomCell {
  favourite: boolean = false;

  @ViewChild('template') template;

  constructor(
    private changes: ChangeDetectorRef,
    private listService: ListService
  ) {}

  ngAfterViewInit() {
    if (this.listService?.filtersForm?.get('[favourite][is not null]').value) {
      this.favourite = true;
      this.changes.detectChanges();
    }
  }

  filterFavourite() {
    this.favourite = !this.favourite;
    this.listService.setFilter('[favourite][is not null]', this.favourite);
    this.listService.setPage(1);
    this.listService.getRows();
    this.changes.detectChanges();
  }
}
